import React from "react";

function Icon2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <g clipPath="url(#clip0_302_44)" opacity="1">
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M17 13.984V6.016H7.016V8H5V4.984C5 4.47 5.469 4 5.984 4h12c.563 0 1.032.469 1.032.984V8.5L23 4.516v10.968L19.016 11.5v3.516c0 .515-.47.984-1.032.984H13v-2.016h4z"
          clipRule="evenodd"
        ></path>
        <path
          stroke="#fff"
          strokeWidth="1.5"
          d="M10.25 14.5a3.75 3.75 0 10-7.5 0v3a3.75 3.75 0 107.5 0v-3zM6.5 11v4m0 0H10m-3.5 0H3"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_302_44">
          <path fill="#fff" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon2;